import { Timeouts } from '../framework/Timeouts';
const shadeTimeoutMs = 1000;
const shadeInc = Math.round((256 / 7000) * shadeTimeoutMs);
export class MechoNetZgn {
    constructor(socket) {
        this.socket = socket;
        this.timeouts = new Timeouts();
        this.uid = 1;
        this.shades = {
            '0.0.0': { position: 0, target: 0, timeout: this.timeouts.create(), uid: this.uid++ },
        };
        this.asyncHandlers = [
            {
                regExp: /^#(\d+\.\d+.\d+).A=([A-Z0-9]+)$/,
                callback: (match) => {
                    const [zone, group, node] = match[1].split('.');
                    // remove leading zeros to create consistent key
                    const key = `${parseInt(zone)}.${parseInt(group)}.${parseInt(node)}`;
                    const cmd = match[2];
                    let shade = this.shades[key];
                    if (shade === undefined) {
                        shade = {
                            position: 0,
                            target: 0,
                            timeout: this.timeouts.create(),
                            uid: this.uid++,
                        };
                        this.shades[key] = shade;
                    }
                    if (cmd === 'ST') {
                        this.stopMoving(shade);
                    }
                    else if (cmd === 'DN') {
                        this.startMoving(shade, 255);
                    }
                    else if (cmd === 'UP') {
                        this.startMoving(shade, 0);
                    }
                    else if (cmd === 'G1' || cmd === 'G2' || cmd === 'G3') {
                        const preset = cmd === 'G1' ? 64 : cmd === 'G2' ? 128 : 192;
                        this.startMoving(shade, preset);
                    }
                    else if (cmd === 'QY') {
                        const value = shade.position.toString(16).toUpperCase();
                        const uidh = (shade.uid >> 8).toString();
                        const uidl = (shade.uid & 0x255).toString();
                        this.socket.send(`!${key}.QY=${value}(${uidh}.${uidl})`);
                    }
                },
            },
            // TODO: no response to invalid commands?
        ];
    }
    onTick(shade) {
        const diff = shade.target - shade.position;
        if (Math.abs(diff) <= shadeInc) {
            shade.position = shade.target;
        }
        else if (diff < 0) {
            shade.position -= shadeInc;
        }
        else if (diff > 0) {
            shade.position += shadeInc;
        }
        if (Math.abs(shade.target - shade.position) < shadeInc) {
            shade.position = shade.target;
            shade.timeout.clear();
        }
        else {
            shade.timeout.set(() => this.onTick(shade), shadeTimeoutMs);
        }
    }
    startMoving(shade, target) {
        shade.timeout.clear();
        shade.target = target;
        shade.timeout.set(() => this.onTick(shade), shadeTimeoutMs);
    }
    stopMoving(shade) {
        shade.timeout.clear();
    }
}
MechoNetZgn.emulatorType = 'socketEmulator';
MechoNetZgn.key = '-NO0QAEpYv0zsvb6bhcU';
